import React, { FC } from 'react'
import { graphql, usePaginationFragment } from 'react-relay'

import {
  Button,
  CardGrid,
  Column,
  Grid,
  HorizontalLine,
  Stack,
  Text,
  useBreakpoint,
  UserCard,
  UserShortCard,
} from '@components'

import { INITIAL_COUNTS } from './GuildMembersScreen'

import { GuildMembersPresentersSection_guild$key } from './__generated__/GuildMembersPresentersSection_guild.graphql'

export const GuildMembersPresentersSection: FC<{
  guild: GuildMembersPresentersSection_guild$key
}> = ({ guild }) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildMembersPresentersSection_guild on Guild
      @refetchable(queryName: "GuildMembersPresentersSectionPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 12 }
        cursor: { type: "Cursor" }
      ) {
        presenters(first: $count, after: $cursor)
          @connection(key: "GuildMembersPresentersSection_guild_presenters") {
          edges {
            node {
              ...UserCard_user
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  const breakpoint = useBreakpoint()

  if (data.presenters.edges.length === 0) {
    return null
  }

  return (
    <Stack gap={4}>
      <Stack direction='horizontal' gap={4} alignItems='center'>
        <Text size={4} variant='cardHeading'>
          Presenters
        </Text>

        <HorizontalLine variant='cardHeading' />
      </Stack>

      <CardGrid
        items={data.presenters.edges}
        renderItem={(edge) => (
          <UserCard user={edge.node} expand={breakpoint !== 0} />
        )}
        breakpointItemsPerRow={INITIAL_COUNTS}
      />

      {hasNext && (
        <Button
          variant='secondary'
          hoverVariant='secondaryHover'
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Text variant='buttonSecondary' size={4}>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Text>
        </Button>
      )}
    </Stack>
  )
}
